<template>
  <fieldset>
    <label>{{ data.title }}</label>
    <select :id="'select-about-'+data.id" @change="Save">
      <option v-if="selected === null || selected === undefined" label="select" value="unset" selected></option>
      <option v-else label="select" value="unset"></option>
      <template v-for="(value, index) in data.options" v-bind:key="index">
        <template v-if="selected === null || selected === undefined">
          <option :value="value.id">{{ value.title }}</option>
        </template>
        <template v-else>
          <option v-if="value.id === selected.item_options_id" :value="value.id" selected>{{ value.title }}</option>
          <option v-else :value="value.id">{{ value.title }}</option>
        </template>
      </template>
    </select>
  </fieldset>
</template>

<script>
import {mapActions} from "vuex";

export default {
  name: "UP_AboutMe_Elem",
  props: {
    data: Object,
    selected: Object
  },
  methods: {
    ...mapActions(['PutCall']),
    Save(e) {

      console.log(e);

      let form = {
        item_id: this.data.id,
        values: [e.target.value],
      }


      this.PutCall({
        endpoint: '/users/update_about',
        options: form,
        callback: (data) => {
          console.log(data);
        },
        on_error: (error) => {
          let error_status = error.response.status;
          console.log(error_status);
        },
      })

    },
  }
}
</script>

<style scoped>

</style>
